import { HttpClient, HttpEvent, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { CommandProgress, Configuration } from '@rocksoft/mdm-sdk-v2';

@Injectable({
  providedIn: 'root',
})
export class AlternativeMdmSdk {
  private readonly httpClient = inject(HttpClient);
  private readonly configuration = inject(Configuration);

  public queueInstallApplicationManualCommandForm(
    fileName: Blob,
    udid: string,
    apiVersion?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<CommandProgress>> {
    if (fileName === null || fileName === undefined) {
      throw new Error(
        'Required parameter fileName was null or undefined when calling queueInstallApplicationManualCommand.'
      );
    }
    if (udid === null || udid === undefined) {
      throw new Error(
        'Required parameter udid was null or undefined when calling queueInstallApplicationManualCommand.'
      );
    }

    let queryParameters = new HttpParams();
    if (apiVersion !== undefined && apiVersion !== null) {
      queryParameters = queryParameters.set('api-version', apiVersion);
    }

    const formParams = new FormData();
    formParams.append('fileName', fileName);

    let headers = new HttpHeaders();
    // authentication (oauth2) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }

    if (!this.configuration.basePath) {
      throw new Error('Base path is not set');
    }

    return this.httpClient.request(
      'post',
      `${this.configuration.basePath}/apple-devices/${encodeURIComponent(udid)}/commands/install-application-manual`,
      {
        body: formParams,
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers,
        observe,
        reportProgress,
      }
    );
  }

  public queueSetWallpaperCommandForm(
    udid: string,
    image?: Blob,
    where?: number,
    apiVersion?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<CommandProgress> {
    if (udid === null || udid === undefined) {
      throw new Error('Required parameter udid was null or undefined when calling queueSetWallpaperCommand.');
    }

    let queryParameters = new HttpParams();
    if (apiVersion !== undefined && apiVersion !== null) {
      queryParameters = queryParameters.set('api-version', apiVersion);
    }

    const formParams = new FormData();
    if (image !== undefined) {
      formParams.append('Image', image);
    }
    if (where !== undefined) {
      formParams.append('Where', where as never);
    }

    let headers = new HttpHeaders();
    // authentication (oauth2) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }

    if (!this.configuration.basePath) {
      throw new Error('Base path is not set');
    }

    return this.httpClient.request<CommandProgress>(
      'post',
      `${this.configuration.basePath}/apple-devices/${encodeURIComponent(udid)}/commands/settings/wallpaper`,
      {
        body: formParams,
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers,
        observe,
        reportProgress,
      }
    );
  }
}
